import { render } from "./ClienteList.vue?vue&type=template&id=57985bec&scoped=true"
import script from "./ClienteList.vue?vue&type=script&lang=js"
export * from "./ClienteList.vue?vue&type=script&lang=js"

import "./ClienteList.vue?vue&type=style&index=0&id=57985bec&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57985bec"]])

export default __exports__